import { FC } from 'react'
import {
  DayPicker,
  DayPickerProps,
  getDefaultClassNames,
} from 'react-day-picker'

const defaultClassNames = getDefaultClassNames()

export const DateRangePicker: FC<DayPickerProps> = ({ ...props }) => {
  return (
    <DayPicker
      {...props}
      classNames={{
        today: `!rounded-[8px]`,
        selected: `bg-black/5 !text-black`,
        range_start: '!bg-black/100 !text-white !rounded-[8px]',
        range_end: '!bg-black/100 !text-white !rounded-[8px]',
        day: '!font-normal !text-sm !text-center !w-[42px] !h-[42px] first:rounded-l-[4px] last:rounded-r-[4px]',
        root: `${defaultClassNames.root} shadow-xl p-5 w-fit rounded-lg`,
        chevron: `${defaultClassNames.chevron} !fill-black`,
        weekdays: '!font-normal !text-sm !text-[#6A6A6A]',
        month_caption: `${defaultClassNames.month_caption} !text-base !font-medium`,
        disabled: `${defaultClassNames.disabled} !line-through`,
      }}
    />
  )
}
